// extracted by mini-css-extract-plugin
export default {"container":"Faq_container__6G+Yb"};